import { Box, Card, CardContent, List, ListItem, ListItemText, TextField, Typography } from '@mui/material';
import React, { useState } from 'react'
import DropdownfromDatabaseList from '../../CustomComponant/DropdownfromDatabaseList';
import apiClient from '../../BaseUrl/apiClient';
import { useNavigate } from 'react-router-dom';
import TokenService from '../../service/TokenService';
import EncryptService from '../../service/EncryptionService';

function MergeIndent() {


    const tokenServiceDetails = TokenService.getUserDetails();
    const logineuname = tokenServiceDetails?.uname;
    const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));

const [poNumber, setPONumber] = useState("");
const [qty,setQty]=useState(0);
const [val,setVal]=useState(0);
const [poItemName,setPOItemName]=useState("");
const [poIndentid,setPOIndentID]=useState("");
  const [list1, setList1] = useState([]);
  const [list2, setList2] = useState([]);
  const navigate = useNavigate();
    const getPOData = async () => {
      if (!poNumber || poNumber.trim() === "") return;
        try {
          const response = await apiClient.post("/MergeIndentListbyPO", {
            ponumber: poNumber,
           
          });
          const data = response.data;
       //   console.log(data[0]);
          setList1(response.data);
          setQty(data[0].POQty);
          setVal(data[0].POValue);
          setPOItemName(data[0].POItemName);
          setPOIndentID(data[0].indentlist);
      

        } catch (error) {
            setQty(0);
            setVal(0);
            setPOItemName('');
            
        }
      };



const sortItems = (items) =>
    [...items].sort((a, b) => a.IndentNumber.localeCompare(b.IndentNumber));

const handleTransferToSelected = (item) => {
    const updatedList1 = list1.filter(
      (i) => i.IndentNumber !== item.IndentNumber
    );
    const updatedList2 = [...list2, item];
    setList1(sortItems(updatedList1));
    setList2(sortItems(updatedList2));
    setQty((qty) => Number(qty) + Number(item.IndentQty));
    setVal((val) => Number(val) + Number(item.IndentValue));
   };

const handleTransferToAvailable = (item) => {
    const updatedList2 = list2.filter(
      (i) => i.IndentNumber !== item.IndentNumber
    );
    const updatedList1 = [...list1, item];
    setList1(sortItems(updatedList1));
    setList2(sortItems(updatedList2));
    setQty((qty) => Number(qty) - Number(item.IndentQty));
    setVal((val) => Number(val) - Number(item.IndentValue));

  };
  const handleClose = () => {
    navigate("../", { replace: true });
  };


  const UpdatPO = async (e) => {
    e.preventDefault();
     if (poItemName.length > 2) {
        const mergeindentList =
        list2.length > 0
          ? [...list2.map((item) => item.id), poIndentid].join(",")
          : poIndentid;
        
      
      try {
        await apiClient.post("/updateMergedData", {
          uname: logineuname,
          ponumber: poNumber,
          mvalue: val,
          mqty: qty,
          mlist: mergeindentList,
          vip: ip,
          
        });
        
        setPOItemName("");
        setQty(0);
        setVal(0);
        setPONumber("");
        setPOIndentID("");
        setList1([]);
        setList2([]);

      } catch (error) {
        console.error("Error updating Merge Data:", error);
      }




        
        


    }
  };







return (
  <Box
    className="merge-indent-page"
    sx={{
      width: "100%",
      maxWidth: "100%",
      minWidth: 0,
      boxSizing: "border-box",
      overflowX: "hidden",
      p: { xs: 1, sm: 1.5, md: 2 },
    }}
  >
    <Card
      className="merge-indent-card"
      sx={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box",
        overflow: "hidden",
        borderRadius: { xs: 2, md: 2.5 },
        border: "1px solid #dbe5f0",
        boxShadow: "0 4px 18px rgba(13, 71, 161, 0.10)",
        background: "#fff",
      }}
    >
      {/* ================= HEADER ================= */}
      <Box
        sx={{
          background:
            "linear-gradient(135deg, #0D47A1 0%, #1565C0 50%, #1976D2 100%)",
          color: "#fff",
          px: { xs: 1.5, sm: 2, md: 2.5 },
          py: { xs: 1.4, sm: 1.6 },
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          minHeight: { xs: 52, sm: 58 },
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "1rem", sm: "1.15rem", md: "1.3rem" },
            fontWeight: 700,
            letterSpacing: "0.2px",
          }}
        >
          Merge Indent
        </Typography>
      </Box>

      <CardContent
        sx={{
          p: { xs: 1.25, sm: 2, md: 2.5 },
          "&:last-child": {
            pb: { xs: 1.5, sm: 2, md: 2.5 },
          },
        }}
      >
        {/* ================= PO INFORMATION ================= */}
        <Box
          sx={{
            border: "1px solid #dbe5f0",
            borderRadius: 2,
            overflow: "hidden",
            mb: { xs: 1.5, sm: 2 },
          }}
        >
          <Box
            sx={{
              px: { xs: 1.25, sm: 1.75 },
              py: 1,
              background:
                "linear-gradient(135deg, #e3f2fd 0%, #f5f9ff 100%)",
              borderBottom: "1px solid #dbe5f0",
            }}
          >
            <Typography
              sx={{
                color: "#0D47A1",
                fontWeight: 700,
                fontSize: { xs: "0.9rem", sm: "1rem" },
              }}
            >
              Purchase Order Information
            </Typography>
          </Box>

          <Box
            sx={{
              p: { xs: 1.25, sm: 1.75 },
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, minmax(0, 1fr))",
                md: "repeat(4, minmax(0, 1fr))",
              },
              gap: { xs: 1.25, sm: 1.5 },
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              boxSizing: "border-box",
            }}
          >
            {/* PO NUMBER */}
            <TextField
              label="PO Number"
              variant="outlined"
              size="small"
              value={poNumber}
              onChange={(e) => setPONumber(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  getPOData();
                }
              }}
              fullWidth
              disabled={!!poItemName}
              sx={{
                minWidth: 0,
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#fff",
                },
              }}
            />

            {/* ITEM NAME */}
            <TextField
              label="Item Name"
              variant="outlined"
              size="small"
              value={poItemName}
              fullWidth
              disabled
              sx={{
                minWidth: 0,
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#f8fafc",
                },
              }}
            />

            {/* TOTAL VALUE */}
            <TextField
              label="Total Value"
              variant="outlined"
              size="small"
              value={val}
              fullWidth
              disabled
              sx={{
                minWidth: 0,
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#f8fafc",
                },
              }}
            />

            {/* TOTAL QUANTITY */}
            <TextField
              label="Total Quantity"
              variant="outlined"
              size="small"
              value={qty}
              fullWidth
              disabled
              sx={{
                minWidth: 0,
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#f8fafc",
                },
              }}
            />
          </Box>
        </Box>

        {/* ================= INDENT SELECTION ================= */}
        <Box
          sx={{
            border: "1px solid #dbe5f0",
            borderRadius: 2,
            overflow: "hidden",
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            boxSizing: "border-box",
          }}
        >
          <Box
            sx={{
              px: { xs: 1.25, sm: 1.75 },
              py: 1,
              background:
                "linear-gradient(135deg, #e3f2fd 0%, #f5f9ff 100%)",
              borderBottom: "1px solid #dbe5f0",
            }}
          >
            <Typography
              sx={{
                color: "#0D47A1",
                fontWeight: 700,
                fontSize: { xs: "0.9rem", sm: "1rem" },
              }}
            >
              Indent Selection
            </Typography>
          </Box>

          <Box
            sx={{
              p: { xs: 1.25, sm: 1.75 },
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "repeat(2, minmax(0, 1fr))",
              },
              gap: { xs: 1.5, md: 2 },
              width: "100%",
              maxWidth: "100%",
              minWidth: 0,
              boxSizing: "border-box",
            }}
          >
            {/* ================= AVAILABLE ================= */}
            <Box
              sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                border: "1px solid #cfddeb",
                borderRadius: 2,
                overflow: "hidden",
                backgroundColor: "#fff",
              }}
            >
              <Box
                sx={{
                  background:
                    "linear-gradient(135deg, #0D47A1 0%, #1565C0 100%)",
                  color: "#fff",
                  px: 1.5,
                  py: 1,
                  textAlign: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    fontWeight: 700,
                  }}
                >
                  Available Indent
                </Typography>
              </Box>

              <Box
                sx={{
                  height: { xs: 250, sm: 280, md: 300 },
                  maxHeight: 300,
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                <List
                  disablePadding
                  sx={{
                    width: "100%",
                    minWidth: 0,
                  }}
                >
                  {list1.length > 0 ? (
                    list1.map((item) => (
                      <ListItem
                        key={item.IndentNumber}
                        button
                        onClick={() => handleTransferToSelected(item)}
                        sx={{
                          width: "100%",
                          maxWidth: "100%",
                          minWidth: 0,
                          boxSizing: "border-box",
                          alignItems: "flex-start",
                          borderBottom: "1px solid #edf2f7",
                          px: { xs: 1, sm: 1.25 },
                          py: { xs: 1, sm: 1.1 },
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          "&:hover": {
                            backgroundColor: "#eaf3ff",
                          },
                        }}
                      >
                        <ListItemText
                          sx={{
                            minWidth: 0,
                            m: 0,
                          }}
                          primary={
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "0.78rem",
                                  sm: "0.85rem",
                                },
                                fontWeight: 600,
                                color: "#17324d",
                                whiteSpace: "normal",
                                overflowWrap: "anywhere",
                                wordBreak: "break-word",
                                lineHeight: 1.45,
                              }}
                            >
                              {`${item.IndentNumber} | Quantity: ${item.IndentQty} | Value: ${item.IndentValue}`}
                            </Typography>
                          }
                          secondary={
                            <Typography
                              component="span"
                              sx={{
                                display: "block",
                                mt: 0.35,
                                fontSize: {
                                  xs: "0.72rem",
                                  sm: "0.78rem",
                                },
                                color: "#607d8b",
                                whiteSpace: "normal",
                                overflowWrap: "anywhere",
                                wordBreak: "break-word",
                              }}
                            >
                              {`ID: ${item.id}`}
                            </Typography>
                          }
                        />
                      </ListItem>
                    ))
                  ) : (
                    <Box
                      sx={{
                        p: 3,
                        textAlign: "center",
                        color: "#78909c",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: "0.8rem", sm: "0.85rem" },
                        }}
                      >
                        No available indent
                      </Typography>
                    </Box>
                  )}
                </List>
              </Box>
            </Box>

            {/* ================= SELECTED ================= */}
            <Box
              sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                border: "1px solid #cfddeb",
                borderRadius: 2,
                overflow: "hidden",
                backgroundColor: "#fff",
              }}
            >
              <Box
                sx={{
                  background:
                    "linear-gradient(135deg, #1565C0 0%, #1976D2 100%)",
                  color: "#fff",
                  px: 1.5,
                  py: 1,
                  textAlign: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    fontWeight: 700,
                  }}
                >
                  Selected Indent
                </Typography>
              </Box>

              <Box
                sx={{
                  height: { xs: 250, sm: 280, md: 300 },
                  maxHeight: 300,
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                <List
                  disablePadding
                  sx={{
                    width: "100%",
                    minWidth: 0,
                  }}
                >
                  {list2.length > 0 ? (
                    list2.map((item) => (
                      <ListItem
                        key={item.IndentNumber}
                        button
                        onClick={() => handleTransferToAvailable(item)}
                        sx={{
                          width: "100%",
                          maxWidth: "100%",
                          minWidth: 0,
                          boxSizing: "border-box",
                          alignItems: "flex-start",
                          borderBottom: "1px solid #edf2f7",
                          px: { xs: 1, sm: 1.25 },
                          py: { xs: 1, sm: 1.1 },
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          "&:hover": {
                            backgroundColor: "#eaf3ff",
                          },
                        }}
                      >
                        <ListItemText
                          sx={{
                            minWidth: 0,
                            m: 0,
                          }}
                          primary={
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "0.78rem",
                                  sm: "0.85rem",
                                },
                                fontWeight: 600,
                                color: "#17324d",
                                whiteSpace: "normal",
                                overflowWrap: "anywhere",
                                wordBreak: "break-word",
                                lineHeight: 1.45,
                              }}
                            >
                              {`${item.IndentNumber} | Quantity: ${item.IndentQty} | Value: ${item.IndentValue}`}
                            </Typography>
                          }
                          secondary={
                            <Typography
                              component="span"
                              sx={{
                                display: "block",
                                mt: 0.35,
                                fontSize: {
                                  xs: "0.72rem",
                                  sm: "0.78rem",
                                },
                                color: "#607d8b",
                                whiteSpace: "normal",
                                overflowWrap: "anywhere",
                                wordBreak: "break-word",
                              }}
                            >
                              {`ID: ${item.id}`}
                            </Typography>
                          }
                        />
                      </ListItem>
                    ))
                  ) : (
                    <Box
                      sx={{
                        p: 3,
                        textAlign: "center",
                        color: "#78909c",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: "0.8rem", sm: "0.85rem" },
                        }}
                      >
                        No selected indent
                      </Typography>
                    </Box>
                  )}
                </List>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* ================= SUMMARY ================= */}
        <Box
          sx={{
            mt: { xs: 1.5, sm: 2 },
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, minmax(0, 1fr))",
            },
            gap: 1.25,
          }}
        >
          <Box
            sx={{
              p: 1.25,
              borderRadius: 1.5,
              background: "#eef6ff",
              border: "1px solid #cfe2ff",
            }}
          >
            <Typography
              sx={{
                fontSize: "0.75rem",
                color: "#607d8b",
                mb: 0.25,
              }}
            >
              Total Quantity
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "1rem", sm: "1.1rem" },
                fontWeight: 700,
                color: "#0D47A1",
              }}
            >
              {qty}
            </Typography>
          </Box>

          <Box
            sx={{
              p: 1.25,
              borderRadius: 1.5,
              background: "#eef6ff",
              border: "1px solid #cfe2ff",
            }}
          >
            <Typography
              sx={{
                fontSize: "0.75rem",
                color: "#607d8b",
                mb: 0.25,
              }}
            >
              Total Value
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "1rem", sm: "1.1rem" },
                fontWeight: 700,
                color: "#0D47A1",
              }}
            >
              {val}
            </Typography>
          </Box>
        </Box>

        {/* ================= ACTIONS ================= */}
        <Box
          sx={{
            mt: { xs: 1.5, sm: 2 },
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, minmax(0, 1fr))",
            },
            gap: 1.25,
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
          }}
        >
          <button
            className="button button1"
            type="button"
            onClick={UpdatPO}
            title="Merge selected indent"
            style={{
              width: "100%",
              minHeight: "42px",
              border: "none",
              borderRadius: "8px",
              background:
                "linear-gradient(135deg, #0D47A1 0%, #1565C0 100%)",
              color: "#fff",
              fontWeight: 700,
              cursor: "pointer",
              boxShadow: "0 3px 8px rgba(13, 71, 161, 0.22)",
            }}
          >
            Merge Indent
          </button>

          <button
            className="button button1"
            type="button"
            onClick={handleClose}
            title="Close"
            style={{
              width: "100%",
              minHeight: "42px",
              border: "none",
              borderRadius: "8px",
              background:
                "linear-gradient(135deg, #c62828 0%, #e53935 100%)",
              color: "#fff",
              fontWeight: 700,
              cursor: "pointer",
              boxShadow: "0 3px 8px rgba(198, 40, 40, 0.20)",
            }}
          >
            Close
          </button>
        </Box>
      </CardContent>
    </Card>
  </Box>
);
}

export default MergeIndent